import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from "vuetify"
import 'vuetify/dist/vuetify.min.css'

import axios from "axios"
import VeeValidate from 'vee-validate'
import Dinero from "dinero.js"
import VueCookies from 'vue-cookies'
//import VueTheMask from 'vue-the-mask'
import moment from 'moment'
import vueDebounce from 'vue-debounce'

import './assets/scripts/session-utils'

// Font Awesome Icons //

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPhoneAlt)
library.add(faStar)
library.add(faBriefcase)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// End of Font Awesome Icons //

//override vue js css
import '@/assets/styles/typography.scss'
import '@/assets/styles/typekit.css'
import '@/assets/styles/main.scss'

/* Vee Validate Configuration */
const vvalidate_config = {
  events: 'blur'
}
/* End Vee Validate Configuration */

Vue.config.productionTip = false
Vue.use(Vuetify);
Vue.prototype.$axios = axios;
Vue.prototype.moment = moment;
Vue.use(VeeValidate, vvalidate_config);
Vue.use(Dinero);
Vue.use(VueCookies);
Vue.use(vueDebounce)
//Vue.use(VueTheMask);
Vue.use(Vuetify, {
  iconfont: 'md'
});

// Listening to multiple events
Vue.use(vueDebounce, {
  listenTo: ['input', 'keyup']
})
 
// Setting a default timer This is set to '300ms' if not specified
Vue.use(vueDebounce, {
  defaultTime: '1000ms'
})

// Insites Components //
let insitesComponents = [
  "ins-card",
  "ins-filter",
  "ins-filter-item",
  "ins-datepicker",
  "ins-sparkline",
  "ins-line-chart",
  "ins-searchbar",
  "ins-table",
  "ins-tr",
  "ins-th",
  "ins-th-checkbox",
  "ins-td",
  "ins-td-checkbox",
  "ins-action",
  "ins-action-item",
  "ins-loader",
  "ins-button",
  "ins-dropdown",
  "ins-bar-chart",
  "ins-radio",
  "ins-toggle-switch",
  "ins-input",
  "ins-base-table",
  "ins-base-table-row",
  "ins-base-table-th",
  "ins-base-table-td",
  "ins-input-tel",
  "ins-select",
  "ins-select-option",
  "ins-textarea",
  "ins-image-picker",
  "ins-backdrop",
  "ins-heading",
  "ins-checkbox",
  "ins-tooltip",
  "ins-tab",
  "ins-tab-item",
  "ins-info-table",
  "ins-credit-card",
  "ins-tag",
  "insites-button",
  "ins-timeline",
  "ins-timeline-item",
  "ins-drawer"
]
Vue.config.ignoredElements = insitesComponents;
// End of Insites Components //

// Custom Icons //
import IconBase from '@/components/IconBase.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconArrowForward from '@/components/icons/arrowForward.vue'
import IconBackDate from '@/components/icons/backdate.vue'
import IconBusinessPhone from '@/components/icons/businessPhone.vue'
import IconCashSearch from '@/components/icons/cashSearch.vue'
import IconCheck from '@/components/icons/check.vue'
import IconCustomerSupport from '@/components/icons/customerSupport.vue'
import IconDisk from '@/components/icons/disk.vue'
import IconDualEducator from '@/components/icons/dualEducator.vue'
import IconEducator from '@/components/icons/educator.vue'
import IconEmail from '@/components/icons/email.vue'
import IconFeedback from '@/components/icons/feedback.vue'
import IconInformation from '@/components/icons/information.vue'
import IconLegalScales from '@/components/icons/legalScales.vue'
import IconMinus from '@/components/icons/minus.vue'
import IconMobilePhone from '@/components/icons/mobilePhone.vue'
import IconPencil from '@/components/icons/pencil.vue'
import IconPlus from '@/components/icons/plus.vue'
import IconPoliceCheck from '@/components/icons/policeCheck.vue'
import IconRefresh from '@/components/icons/refresh.vue'
import IconSearch from '@/components/icons/search.vue'
import IconService from '@/components/icons/service.vue'
import IconSmallBusiness from '@/components/icons/smallBusiness.vue'
import IconStar from '@/components/icons/star.vue'
import IconStarCheck from '@/components/icons/starCheck.vue'
import IconAddCard from '@/components/icons/addCard.vue'

Vue.component('IconBase', IconBase)
Vue.component('IconArrowBack', IconArrowBack)
Vue.component('IconArrowForward', IconArrowForward)
Vue.component('IconBackDate', IconBackDate)
Vue.component('IconBusinessPhone', IconBusinessPhone)
Vue.component('IconCashSearch', IconCashSearch)
Vue.component('IconCheck', IconCheck)
Vue.component('IconCustomerSupport', IconCustomerSupport)
Vue.component('IconDisk', IconDisk)
Vue.component('IconDualEducator', IconDualEducator)
Vue.component('IconEducator', IconEducator)
Vue.component('IconEmail', IconEmail)
Vue.component('IconFeedback', IconFeedback)
Vue.component('IconInformation', IconInformation)
Vue.component('IconLegalScales', IconLegalScales)
Vue.component('IconMinus', IconMinus)
Vue.component('IconMobilePhone', IconMobilePhone)
Vue.component('IconPencil', IconPencil)
Vue.component('IconPlus', IconPlus)
Vue.component('IconPoliceCheck', IconPoliceCheck)
Vue.component('IconRefresh', IconRefresh)
Vue.component('IconSearch', IconSearch)
Vue.component('IconService', IconService)
Vue.component('IconSmallBusiness', IconSmallBusiness)
Vue.component('IconStar', IconStar)
Vue.component('IconStarCheck', IconStarCheck)
Vue.component('IconAddCard', IconAddCard)
// End of Custom Icons //

Vue.filter('formatDate', function(value) {
  if(!value) return ''
  value = value.toString()
  return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
})

Vue.mixin({
  data() {
    return {
      get baseURL() {
        if(window.location.origin === 'http://localhost:8080')
          return 'https://fda-insurance-uat-2.staging.oregon.platform-os.com'
        return window.location.origin;
      },
      get transactionsAPIToken() {
        switch(window.location.origin) {
          case 'https://fda-insurance.prod01.sydney.platformos.com':
          case 'https://insurance.familydaycare.com.au':
            return '933fdb6661f26db6bdd15bab3bdf602c'
          default:
            //return 'ec05a3130c77cde90ccdcb3796c9dc77'
            return 'bed04d5101691c6b6550220c870d6539'
        }
      },
      get environment() {
          switch(window.location.origin) {
            case 'https://fda-insurance.prod01.sydney.platformos.com':
            case 'https://insurance.familydaycare.com.au':
              return 'prod';
            default:
              return 'staging';
          }
      }
    }
  },
  methods: {
    isInvalid($value) {
      switch($value) {
        case undefined:
        case null:
        case "":
          return true
        default:
          return false
      }
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
